export const YOTI_APP = 'yoti'
export const EASYID_APP = 'easyid'
export const SMART_ID_APP = 'smart-id'

